
export const findBtnAuth = (list, func) => {
	  for (const data of list) {
	  if (func(data)) return data
	  if (data.children) {
		const res = findBtnAuth(data.children, func)
		if (res) return res
	  }
	  }
	  return ''
  }

/**
 * 
 * @description 时间转换 61秒 => 0小时1分钟1秒
 * @param {string|number} val 要转换的秒数
 * @returns {string}
 */
export const timeTransform = (val)=> {
	let { hours, minutes, remainingSeconds } = {
		hours: Math.floor(val / 3600),
		minutes: Math.floor((val % 3600) / 60),
		remainingSeconds: val % 60
	};
	let timeString = `${hours}小时${minutes}分钟${remainingSeconds}秒`;
	return timeString
}

// 数字两位数补0 eg. 20 -> 20.00; 26.123 -> 26.12
export const numberTransform = (value)=> {
	var value = Math.round(parseFloat(value) * 100) / 100;
	var s = value.toString().split(".");
	if (s.length == 1) {
	  value = value.toString() + ".00";
	  return value;
	}
	if (s.length > 1) {
	  if (s[1].length < 2) {
		value = value.toString() + "0";
	  }
	  return value;
	}
}